import { Cell, Column } from '../types';

/**
 * Resolves per-row cell props from a column's static config or resolver.
 *
 * Currently allocates on every call, which is fine because rows are replaced
 * wholesale on edit (new object identity) — React.memo on Cell already gates
 * re-rendering.
 *
 * If we ever switch to cell-level in-place updates (keeping the same row
 * reference), a WeakMap<Row, Map<ColumnKey, Cell>> cache would be needed
 * here to avoid repeated allocations.
 */
export function getCell<R, SR = unknown>(column: Column<R, SR>, row: R): Cell<R, SR> {
  const { renderCell, renderEditCell, locked, required, empty, valid, displayCellContent, className, dataAttrs } =
    typeof column.cell === 'function' ? column.cell(row) : column.cell;

  return {
    state: {
      locked: locked ?? false,
      required: required ?? false,
      empty: empty ?? false,
      valid: valid ?? true,
    },
    renderCell,
    renderEditCell,
    displayCellContent: displayCellContent ?? false,
    cellClass: className,
    dataAttrs,
  };
}
